/**
 * BoardV3 Local Types
 */

import type { Task } from '../../types';

/**
 * Drag state for the board
 */
export interface BoardV3DragState {
  activeTask: Task | null;
  initialPosition: { x: number; y: number } | null;
  snapTarget: { column: string; day: number } | null;
  isBulkDrag: boolean;
  bulkDragCount: number;
  initialDayIndex: number | null;
  minSelectedDayIndex: number | null;
}

/**
 * Create initial drag state
 */
export function createInitialDragState(): BoardV3DragState {
  return {
    activeTask: null,
    initialPosition: null,
    snapTarget: null,
    isBulkDrag: false,
    bulkDragCount: 0,
    initialDayIndex: null,
    minSelectedDayIndex: null,
  };
}
